import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Unveil } from '@homeaway/react-unveil';
import EdapModuleView from '../EdapModuleView';
import TrendingCard from './TrendingCard';
import Carousel from '../Carousel';
import TrendingModal from './TrendingModal/AsyncTrendingModal';
import {
  handleEdapClick,
  triggerEdapEvent
} from '../../utils/edap';
import {
  TRENDING_DESTINATION_LINK_CLICK,
  TRENDING_CLICK_PREV,
  TRENDING_CLICK_NEXT,
  MODULE_VIEW_EVENT_OPTIONS
} from './events';

import './Trending.less';

const DEFAULT_STATE = {
  isOpen: false,
  locationQuery: '',
  url: {
    slpUrl: ''
  }};

class Trending extends Component {
  static propTypes = {
    edapModuleViewEventOptions: PropTypes.shape({ actionlocation: PropTypes.string }),
    showTrendingModal: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    title: PropTypes.string
  }

  static defaultProps = {
    data: []
  }

  state = DEFAULT_STATE;

  // Arrow handlers
  handlePreviousClick() {
    triggerEdapEvent(TRENDING_CLICK_PREV);
  }

  handleNextClick() {
    triggerEdapEvent(TRENDING_CLICK_NEXT);
  }

  // Modal
  handleOpenModal = ({ lbsId, slpUrl, locationQuery }, position) => (evt) => {
    evt.preventDefault();
    triggerEdapEvent(TRENDING_DESTINATION_LINK_CLICK, { lbsUuid: lbsId, position });
    this.setState({ isOpen: true, url: { slpUrl }, locationQuery });
  }

  handleCloseModal = () => {
    this.setState({ ...DEFAULT_STATE });
  }

  handleCardClick = ({ lbsUuid, position }) => (evt) => {
    handleEdapClick(TRENDING_DESTINATION_LINK_CLICK, { lbsUuid, position })(evt);
  }

  render() {
    const {
      edapModuleViewEventOptions,
      title,
      data,
      showTrendingModal
    } = this.props;

    const { isOpen, locationQuery, url } = this.state;

    return (
      !!data.length &&
        <section className="Content__section">
          <EdapModuleView eventOptions={edapModuleViewEventOptions || MODULE_VIEW_EVENT_OPTIONS} >
            <Unveil>
              <TrendingModal
                isOpen={isOpen}
                locationQuery={locationQuery}
                url={url}
                handleClose={this.handleCloseModal}
              />
            </Unveil>
            <Carousel
              title={title}
              onPreviousClick={this.handlePreviousClick}
              onNextClick={this.handleNextClick}
            >
              {data.map((item, index) => (
                <TrendingCard
                  key={item.lbsId}
                  locationQuery={item.locationQuery}
                  onClick={showTrendingModal
                    ? this.handleOpenModal(item, index + 1)
                    : this.handleCardClick({ lbsUuid: item.lbsId, position: index + 1 })}
                  {...item}
                />
              ))}
            </Carousel>
          </EdapModuleView>
        </section>
    );
  }
}

export default Trending;
